import React from "react";
import DataTableDuracionEntrevista from "../DataTable/DataTableDuracionEntrevista";

const DuracionEntrevistaTotal = () => {
  return (
    <section className="section-container">
      <DataTableDuracionEntrevista/>
    </section>
  );
};

export default DuracionEntrevistaTotal;
